@if (label()) {
  <label [for]="id()" class="block mb-1.5 text-sm font-medium text-heading">
    {{label()}}@if (required()) {<span class="font-semibold text-danger">*</span>}
  </label>
}

<select #inputElement [autofocus]="autofocus()" [id]="id()" [(ngModel)]="selected" [disabled]="disabled()" [required]="required()" class="bg-white border border-gray-300 text-gray-900 text-base sm:text-sm rounded-lg focus:ring-brand focus:border-brand block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-brand dark:focus:border-brand disabled:text-fg-disabled">
  @if (placeholder()) {
    <option value="" hidden>{{placeholder()}}</option>
  }

  @for(option of options(); track $index) {
    <option [value]="option.value">{{option.label}}</option>
  }
</select>

@if (help()) {
  <p class="text-xs text-body px-2">{{help()}}</p>
}
